import { jsxs as n, jsx as e } from "react/jsx-runtime";
import { m as l } from "motion/react";
import { useAnimateFadeIn as c } from "../../../animation/animation.js";
import { Shortcut as d } from "../../elements/shortcut/shortcut.js";
import i from "./shortcut-list-block.module.less.js";
const b = ({ title: s, shortcuts: t, maxItemsPerRowDesktop: r = "six" }) => {
  const a = c({ whileInView: !0, easing: "easeInOut" });
  return /* @__PURE__ */ n(l.section, { ...a, className: "max-width padded-sides centered space-mb-2xl", children: [
    s && /* @__PURE__ */ e("p", { className: [i.title, "body-base bold"].join(" "), children: s }),
    t && /* @__PURE__ */ e("ul", { className: [i.list, i[r]].join(" "), children: t.map((m, o) => /* @__PURE__ */ e("li", { className: i.item, children: /* @__PURE__ */ e(d, { ...m }) }, o)) })
  ] });
};
export {
  b as ShortcutListBlock,
  b as default
};
